import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { Box, Button, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Proposition } from "../../utils/types";
import * as S from "./PropositionCard.styled";
import { setProposalApproval } from "../../database/queries/commands";

import React, { useState } from "react";
import { PropositionCardHeader } from "./PropositionCardHeader";
import { StatusMessage } from "../StatusMessage";
import { useGoogleAuthContext } from "../../contexts/GoogleAuthContext";

export const PropositionCard = (proposition: Proposition) => {
  const { user } = useGoogleAuthContext();
  const [isApprove, setApprove] = useState(false);
  const [status, setStatus] = useState(proposition.status);
  const navigate = useNavigate();

  const handleApproveProposition = async () => {
    setApprove(true);
    await setProposalApproval(proposition.id, true, user?.email);
    setStatus("APPROVED");
  };

  const handleDenyProposition = async () => {
    setApprove(false);
    await setProposalApproval(proposition.id, false, user?.email);
    setStatus("DENIED");
  };

  const handleGoToDetails = (
    _: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>
  ) => {
    navigate(`/propostas/${proposition.uuid}`, {
      state: {
        ...proposition,
      },
    });
  };

  const renderActionButtons = () => {
    if (status === "SENT") {
      return (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
              backgroundColor: "#00D387",
              color: "#fff",
              fontWeight: "bold",
              boxShadow: "none",
              textTransform: "none",
              fontSize: "small",
            }}
            onClick={handleApproveProposition}
          >
            Aprovar
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
              backgroundColor: "#FF5E51",
              color: "#fff",
              fontWeight: "bold",
              boxShadow: "none",
              textTransform: "none",
              fontSize: "small",
            }}
            onClick={handleDenyProposition}
          >
            Negar
          </Button>
        </Box>
      );
    } else {
      return (
        <Button
          variant="contained"
          sx={{
            borderRadius: 2,
            backgroundColor: "#535676",
            color: "#fff",
            fontWeight: "bold",
            boxShadow: "none",
            textTransform: "none",
            fontSize: "small",
          }}
          onClick={handleGoToDetails}
        >
          Ver proposta
        </Button>
      );
    }
  };

  return (
    <S.PropositionCard
      id={`${proposition.uuid}-card`}
      sx={{
        borderBottom: `8px solid ${proposition.theme?.color ?? "#ccc"}`,
        width: "100%",
      }}
    >
      <PropositionCardHeader
        title={proposition.title}
        location={proposition.location}
        theme={proposition.theme}
        id={proposition.uuid}
        date={`${proposition.createdAt.toDate()}`}
        createdBy={proposition.createdBy}
      />
      <CardContent
        id={`${proposition.uuid}-description`}
        sx={{ padding: 0, width: "100%" }}
      >
        <Typography variant="body2" style={{ color: "#171721", width: "100%" }}>
          {proposition.description}
        </Typography>
      </CardContent>
      <Grid
        component="section"
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ paddingTop: 0, verticalAlign: "center" }}
      >
        <Box sx={{ display: "inline-flex", gap: 1, verticalAlign: "middle" }}>
          <StatusMessage status={status} />
        </Box>
        {renderActionButtons()}
      </Grid>
    </S.PropositionCard>
  );
};
